import {debounce} from './utils/helpers';

export const nav = () => {
    const $ = jQuery;

    const body = $('body');
    const navWrapper = $('#sitewide-navigation');
    const megaTriggers = $('#sitewide-navigation .megamenu-trigger > a');
    const sectorTriggers = $('#sitewide-navigation .mega-menu-sector-wrapper');
    const optionTriggers = $('#sitewide-navigation .mega-menu-option-wrapper');
    const linkTriggers = $('#sitewide-navigation .mega-menu-mobile-links-wrapper .mega-menu-links-wrapper > div');
    const spotlightTriggers = $('#sitewide-navigation .mega-menu-spotlight-trigger');
    const testOpensExclusiveMobile = $('#sitewide-navigation .mega-menu-opens-exclusive-mobile');

    const navBreakpoint = 1200;

    const navOpenBtn = $('#nav-open');
    const navCloseBtn = $('#nav-close');
    const backBtn = $('#mega-menu-back-button');

    const careersNav = $('#careers-navigation');
    const careersLink = careersNav.find('.careers-link');

    const isTest = () => {
        return true;
    };

    const handleCareersClick = (e) => {
        if (window.innerWidth < navBreakpoint) {
            e.preventDefault();

            $(e.currentTarget).toggleClass('open');
            careersNav.find('ul').slideToggle();
        }
    }

    const handleNavOpen = (e) => {
        e.preventDefault();

        navWrapper.addClass('open');
        body.addClass('mobile-nav-open');
        navOpenBtn.removeClass('show');
        navCloseBtn.addClass('show');
    }

    const handleNavClose = (e) => {
        e.preventDefault();

        navWrapper.find('.open, .show').removeClass('open').removeClass('show');
        navWrapper.removeClass('open');
        body.removeClass('mobile-nav-open');
        navCloseBtn.removeClass('show');
        navOpenBtn.addClass('show');
        backBtn.trigger('click');
    }

    const testMegaTriggersClick = (e) => {
        const trigger = e.currentTarget;
        const $triggerParent = $(trigger).parent();
        const $firstItem = $triggerParent.find('.mega-menu-option-wrapper').first();
        const isMobile = window.innerWidth < navBreakpoint;

        $('.mega-menu-sector-options-wrapper.open').removeClass('open');
        $('.mega-menu-option-details-wrapper.open').removeClass('open');
        $('.mega-menu-option-detail-wrapper.open').removeClass('open');

        if ($triggerParent.hasClass('open')) {
            $triggerParent.removeClass('open');
            navWrapper.find('.open, .show').removeClass('open').removeClass('show');
            if (window.innerWidth >= navBreakpoint) {
                navCloseBtn.trigger('click');
            }
            $triggerParent.find('.mega-menu-sector-options-wrapper').removeClass('open');
        } else {
            megaTriggers.parent().removeClass('open');
            $triggerParent.addClass('open');
            navOpenBtn.trigger('click');
            $triggerParent.find('.mega-menu-sector-options-wrapper').addClass('open');
            if (!$firstItem.hasClass('open') && !isMobile) {
                $firstItem.click();
            }
        }
    }

    const handleMegaTriggerClick = (e) => {
        e.preventDefault();

        if (isTest()) {
            testMegaTriggersClick(e);
            return;
        }

        const trigger = e.currentTarget;
        const triggerParent = $(trigger).parent();

        if (triggerParent.hasClass('open')) {
            triggerParent.removeClass('open');
            navWrapper.find('.open, .show').removeClass('open').removeClass('show');
            if (window.innerWidth >= navBreakpoint) {
                navCloseBtn.trigger('click');
            }
        } else {
            megaTriggers.parent().removeClass('open');
            triggerParent.addClass('open');
            navOpenBtn.trigger('click');
        }
    }

    const handleSectorTriggerClick = (e) => {

        const trigger = e.currentTarget;
        const sectorSlug = $(trigger).data('sector');
        const sectorsWrapper = $(trigger).parent();
        const optionsWrapper = sectorsWrapper.siblings('.mega-menu-options-wrapper');
        const sectorOptionsWrapper = optionsWrapper.children('[data-sector="' + sectorSlug + '"]');

        if ($(trigger).hasClass('link')) {
            return true;
        }

        $('.mega-menu-option-details-wrapper.open').removeClass('open');
        $('.mega-menu-option-detail-wrapper').removeClass('open');

        if (window.innerWidth >= navBreakpoint) {
            if (sectorOptionsWrapper.hasClass('open')) {
                sectorOptionsWrapper.removeClass('open');
                sectorOptionsWrapper.prev('.h2').removeClass('show');
                optionsWrapper.removeClass('open');
            } else {
                optionsWrapper.children().removeClass('open').removeClass('show');
                sectorOptionsWrapper.addClass('open');
                sectorOptionsWrapper.prev('.h2').addClass('show');
                optionsWrapper.addClass('open');
            }
        } else {
            sectorOptionsWrapper.addClass('open');
            sectorOptionsWrapper.prev('.h2').addClass('show');
            optionsWrapper.addClass('open');
        }

        body.addClass('back-active');
    }

    const testHandleSectorTriggerClick = (e) => {

        const trigger = e.currentTarget;
        const sectorSlug = $(trigger).data('option');
        const sectorsWrapper = $(trigger).parent();
        const optionsWrapper = sectorsWrapper.siblings('.mega-menu-option-details-wrapper');
        const sectorOptionsWrapper = optionsWrapper.children('[data-option="' + sectorSlug + '"]');

        if ($(trigger).hasClass('link')) {
            return true;
        }

        $('.mega-menu-option-details-wrapper.open').removeClass('open');
        $('.mega-menu-option-detail-wrapper').removeClass('open');

        if (window.innerWidth >= navBreakpoint) {
            if (sectorOptionsWrapper.hasClass('open')) {
                sectorOptionsWrapper.removeClass('open');
                sectorOptionsWrapper.prev('.h2').removeClass('show');
                optionsWrapper.removeClass('open');
            } else {
                optionsWrapper.children().removeClass('open').removeClass('show');
                sectorOptionsWrapper.addClass('open');
                sectorOptionsWrapper.prev('.h2').addClass('show');
                optionsWrapper.addClass('open');
            }
        } else {
            sectorOptionsWrapper.addClass('open');
            sectorOptionsWrapper.prev('.h2').addClass('show');
            optionsWrapper.addClass('open');
        }

        body.addClass('back-active');
    }

    const testOptionTriggerClick = (e) => {
        const trigger = e.currentTarget;
        const activeOptionsWrapper = $(trigger).parents('.mega-menu-sector-options-wrapper.open');
        const activeDetailsWrapper = activeOptionsWrapper.next();
        const optionDetailWrappers = activeDetailsWrapper.children('.mega-menu-option-detail-wrapper');
        const optionSlug = $(trigger).attr('data-option');
        const activeDetailWrapper = activeDetailsWrapper.children('[data-option="' + optionSlug + '"]');

        optionDetailWrappers.not(activeDetailWrapper).removeClass('open');

        //if(window.innerWidth > navBreakpoint) {
        activeDetailWrapper.toggleClass('open');
        //}

        if ($(trigger).hasClass('open')) {
            activeDetailsWrapper.removeClass('open');
            $(trigger).removeClass('open');
        } else {
            optionTriggers.not(trigger).removeClass('open');
            $(trigger).addClass('open');

            if (window.matchMedia('(min-width:' + navBreakpoint + 'px)').matches) {
                activeDetailsWrapper.addClass('open');
            }
        }
    }

    const handleOptionTriggerClick = (e) => {
        e.preventDefault();
        const trigger = e.currentTarget;

        if (isTest()) {

            if ($(trigger).hasClass('link')) {
                window.location.href = $(trigger).attr('href');
                return true;
            }

            testOptionTriggerClick(e);
            return;
        }

        const activeOptionsWrapper = $(trigger).parents('.mega-menu-options-wrapper.open');
        const activeDetailsWrapper = activeOptionsWrapper.next();
        const optionDetailWrappers = activeDetailsWrapper.children('.mega-menu-option-detail-wrapper');
        const optionSlug = $(trigger).data('option');
        const activeDetailWrapper = activeDetailsWrapper.children('[data-option="' + optionSlug + '"]');

        optionDetailWrappers.not(activeDetailWrapper).removeClass('open');
        activeDetailWrapper.toggleClass('open');

        if ($(trigger).hasClass('open')) {
            activeDetailsWrapper.removeClass('open');
            $(trigger).removeClass('open');
        } else {
            optionTriggers.not(trigger).removeClass('open');
            $(trigger).addClass('open');
            activeDetailsWrapper.addClass('open');
        }
    }

    const handleLinkTriggerClick = (e) => {
        e.preventDefault();

        const trigger = e.currentTarget;
        linkTriggers.not(trigger).parent().removeClass('open');

        $(trigger).parent().toggleClass('open');
    }

    const handleSpotlightTriggerClick = (e) => {
        if (window.innerWidth < navBreakpoint) {
            const trigger = e.currentTarget;
            $(trigger).parent().toggleClass('open');
        }
    }

    const handleBackClick = (e) => {
        e.preventDefault();

        navWrapper.find('.open, .show').removeClass('open').removeClass('show');

        body.removeClass('back-active');
    }

    const closeOnOutsideClick = (e) => {

        if (!isTest()) return;

        if (e.target === document.querySelector('.mega-menu-option-details-wrapper.open')) {
            e.target.closest('.megamenu-trigger.open').querySelector('a').click()
        }
    }

    const mobileMenuHandler = () => {
        testOpensExclusiveMobile.off('click', testHandleSectorTriggerClick);

        if (window.matchMedia('(max-width:' + navBreakpoint + 'px)').matches) {
            testOpensExclusiveMobile.on('click', testHandleSectorTriggerClick);
        }
    }

    const debouncedResizeHandler = debounce(mobileMenuHandler, 250);

    navOpenBtn.on('click', handleNavOpen);
    navCloseBtn.on('click', handleNavClose);
    backBtn.on('click', handleBackClick);
    megaTriggers.on('click', handleMegaTriggerClick);
    sectorTriggers.on('click', handleSectorTriggerClick);
    optionTriggers.on('click', handleOptionTriggerClick);
    linkTriggers.on('click', handleLinkTriggerClick);
    spotlightTriggers.on('click', handleSpotlightTriggerClick);
    careersLink.on('click', handleCareersClick);

    document.addEventListener('click', closeOnOutsideClick);
    window.addEventListener('resize', debouncedResizeHandler);

    mobileMenuHandler();
};